import { Controller } from "@hotwired/stimulus"

// Simple controller for the upload form in the popup
// Just handles form submission, then dispatches event for main page to handle streaming
export default class extends Controller {
  static targets = ["form", "fileInput", "submitButton", "status"]
  static values = {
    prepareUrl: String,
    streamUrl: String,
    maxFileSize: { type: Number, default: 500 * 1024 * 1024 } // 500 MB
  }

  async submit(event) {
    event.preventDefault()

    const fileInput = this.fileInputTarget
    if (!fileInput.files.length) {
      this.showStatus("Please select a zip file", "error")
      return
    }

    // Check file size
    const file = fileInput.files[0]
    if (file.size > this.maxFileSizeValue) {
      this.showStatus("File size exceeds 500 MB limit. Split your upload into multiple smaller zip files.", "error")
      return
    }

    // Disable submit button and show progress
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = "Uploading..."
    this.showStatus("Uploading file...", "info")

    // Upload file and get session ID
    const formData = new FormData(this.formTarget)

    try {
      const response = await fetch(this.prepareUrlValue, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (!response.ok) {
        if (data.errors) {
          this.showStatus(data.errors.join(', '), "error")
        } else {
          this.showStatus(data.error || 'Upload failed', "error")
        }
        this.resetForm()
        return
      }

      // Dispatch event for repository page to handle streaming
      window.dispatchEvent(new CustomEvent('upload:ready', {
        detail: {
          sessionId: data.session_id,
          streamUrl: this.streamUrlValue,
          importMode: data.import_mode,
          warnings: data.warnings
        }
      }))

      // Close the popup
      this.closePopup()

    } catch (error) {
      this.showStatus(`Upload error: ${error.message}`, "error")
      this.resetForm()
    }
  }

  showStatus(message, type) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      const colors = {
        info: 'text-blue-600',
        error: 'text-red-600',
        warning: 'text-yellow-600'
      }
      this.statusTarget.className = `text-sm font-medium ${colors[type] || 'text-gray-600'}`
    }
  }

  resetForm() {
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.textContent = "Import"
  }

  closePopup() {
    const modalDiv = document.getElementById('modaldiv')
    if (modalDiv && modalDiv.parentElement) {
      modalDiv.parentElement.removeAttribute("src")
      modalDiv.remove()
    }
  }
}
